{
  "ga-IE": {
    "model": {
      "profile": {
        "id": "Aitheantas Úsáideora",
        "userName": "Ainm úsáideora",
        "email": "Seoladh ríomhphoist",
        "emailConfirmed": "Ríomh-phost díolaimh",
        "phoneNumber": "Uimhir ghutháin",
        "phoneNumberConfirmed": "Uimhir ghutháin deimhnithe.",
        "twoFactorEnabled": "Fuascailt dhá fhachthar",
        "lockoutEnd": "Deireadh na tréimhse gluaiseachta",
        "lockoutEnabled": "Socruithe glasáil ar siúl",
        "accessFailedCount": "Líon na n-iarrachtaí teipte",
        "firstName": "Ainm céad",
        "lastName": "Sloinne",
        "picture": "Pictiúr avatar",
        "organisationName": "Eagra",
        "name": "Ainm",
        "roles": "Rólai"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Dearbhaithe"
      },
      "action": {
        "resetPassword.tooltip": "Seolfaidh instruictí athshocrú pasfhocal chuig an úsáideoir trí ríomhphost."
      },
      "message": {
        "resetPassword.success": "Curaíodh ríomhphost chuig an úsáideoir le treoracha maidir le pasfhocal a athrú."
      }
    }
  }
}